import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import FastenerCheckboxes from './FastenerCheckboxes.js'
import { setCanProceedToNextStep, setFastenerPlacement } from '../actions/generalActions.js'
import { withRoutingTracker } from '../HOC/withRoutingTracker.js'
import { APP_URL } from '../utils/config.js'
import { getEstimate, getHasZipperOrientation, sendGtag } from '../utils/utils.js'
import { debounce } from 'lodash'
import StepTitle from './StepTitle/index.js'

const letters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j']

class CushionFastenerPlacementSelector extends PureComponent {
  constructor(props) {
    super(props)

    const {
      params: { type, shape },
    } = props

    this.state = {
      checkboxes: [],
      mirroredCheckboxes: [],
      isMobileLayout: false,
      isChaise:
        type.id === '11568' && ['737', '734', '735', '738', '736', '739'].includes(shape?.id),
    }
  }

  componentDidMount() {
    const { isChaise } = this.state
    const { dispatch, params, general } = this.props
    const { type, category } = params
    const { fastenerId, fastenersPlacement } = params.fasteners
    const { fastenerPlacement } = general
    const { checkboxes, mirroredCheckboxes } = fastenerPlacement
    const noCheckboxesSelected = checkboxes
      .concat(mirroredCheckboxes)
      .every((placement) => parseInt(placement) === 0)

    if (type.id === '11569' && noCheckboxesSelected) {
      const checkboxes = Array(8).fill(0)
      dispatch(
        setFastenerPlacement({
          checkboxes: checkboxes,
          mirroredCheckboxes: checkboxes,
        }),
      )
      this.setState({
        checkboxes: checkboxes,
        mirroredCheckboxes: checkboxes,
      })
    } else if (isChaise && noCheckboxesSelected) {
      // If cushion is Chaise
      const nrOfBreaks = params.shape.name.replace(/[^0-9]/g, '')
      // nr of fasteners is going to be initial of 5, + 2 for each break
      const nrOfFasteners = +nrOfBreaks * 2 + 5
      const checkboxes = Array(nrOfFasteners).fill(0)

      dispatch(
        setFastenerPlacement({
          checkboxes: checkboxes,
          mirroredCheckboxes: checkboxes,
        }),
      )
      this.setState({
        checkboxes: checkboxes,
        mirroredCheckboxes: checkboxes,
      })
    }

    if (category === '28' || type.id === '11569' || type.id === '12072') {
      const checkboxes = Array(8).fill(0)
      dispatch(
        setFastenerPlacement({
          checkboxes: checkboxes,
          mirroredCheckboxes: checkboxes,
        }),
      )
      this.setState({
        checkboxes: checkboxes,
        mirroredCheckboxes: checkboxes,
      })
    }

    if (fastenerId !== 'fasteners') {
      const fastenerPlacementCheckboxesParam = fastenersPlacement?.checkboxes.split('').map(Number)
      const fastenerPlacementMirroredCheckboxesParam = fastenersPlacement?.mirroredCheckboxes
        .split('')
        .map(Number)
      if (
        fastenerId &&
        fastenerId.toString() !== '718' &&
        fastenerPlacementCheckboxesParam &&
        fastenerPlacementMirroredCheckboxesParam &&
        fastenerPlacementCheckboxesParam
          .concat(fastenerPlacementMirroredCheckboxesParam)
          .some((placement) => parseInt(placement) === 1)
      ) {
        dispatch(
          setFastenerPlacement({
            checkboxes: fastenerPlacementCheckboxesParam,
            mirroredCheckboxes: fastenerPlacementMirroredCheckboxesParam,
          }),
        )
        setTimeout(() => {
          this._getPrice()
        }, 100)
        this.setState({
          checkboxes: fastenerPlacementCheckboxesParam,
          mirroredCheckboxes: fastenerPlacementMirroredCheckboxesParam,
        })
      }

      if (
        fastenerPlacementCheckboxesParam &&
        fastenerPlacementMirroredCheckboxesParam &&
        fastenerPlacementCheckboxesParam
          .concat(fastenerPlacementMirroredCheckboxesParam)
          .some((placement) => parseInt(placement) === 1)
      ) {
        dispatch(setCanProceedToNextStep(true))
      } else {
        dispatch(setCanProceedToNextStep(false))
      }
    }

    if (checkboxes.concat(mirroredCheckboxes).some((placement) => parseInt(placement) === 1)) {
      dispatch(
        setFastenerPlacement({
          checkboxes: checkboxes,
          mirroredCheckboxes: mirroredCheckboxes,
        }),
      )
      this.setState({
        checkboxes: checkboxes,
        mirroredCheckboxes: mirroredCheckboxes,
      })
    }

    if (window.innerWidth < 769) {
      this.setState({ isMobileLayout: true })
    }

    window.addEventListener('resize', this.checkForMobileLayout)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkForMobileLayout)
  }

  checkForMobileLayout = debounce(() => {
    this.setState({ isMobileLayout: window.innerWidth <= 769 })
  }, 100)

  _getPrice = () => {
    const { dispatch, general, params } = this.props
    setTimeout(() => {
      getEstimate(dispatch, general, params)()
    }, 100)
  }

  _setFastenerPlacement =
    (index, shouldCheckMirroredCheckbox) => (hasClickedOnMirroredCheckbox) => {
      const { dispatch, general } = this.props
      const { fastenerPlacement } = general
      const { checkboxes, mirroredCheckboxes } = fastenerPlacement
      const checkboxesCopy = [...checkboxes]
      const mirroredCheckboxesCopy = [...mirroredCheckboxes]

      if (hasClickedOnMirroredCheckbox) {
        mirroredCheckboxesCopy[index] = 1 - parseInt(mirroredCheckboxes[index])
        if (shouldCheckMirroredCheckbox) {
          checkboxesCopy[index] = 1 - parseInt(mirroredCheckboxes[index])
        }
      } else {
        checkboxesCopy[index] = 1 - parseInt(checkboxes[index])
        if (shouldCheckMirroredCheckbox) {
          mirroredCheckboxesCopy[index] = 1 - parseInt(checkboxes[index])
        }
      }
      sendGtag('select_placement_fasteners', `Fastener Placement ${checkboxesCopy.join('')}-${mirroredCheckboxesCopy.join('')}`)

      dispatch(
        setFastenerPlacement({
          checkboxes: checkboxesCopy,
          mirroredCheckboxes: mirroredCheckboxesCopy,
        }),
      )
      dispatch(
        setCanProceedToNextStep(
          checkboxesCopy
            .concat(mirroredCheckboxesCopy)
            .some((placement) => parseInt(placement) === 1),
        ),
      )
      setTimeout(() => {
        this._getPrice()
      }, 200)
    }

  _getChaiseImage = (shape) => {
    try {
      return require(`../../assets/fasteners/fastener-placement-${shape.slug}.webp`).default
    } catch (error) {
      console.error('Failed to load image:', error) // eslint-disable-line
      return ''
    }
  }

  _getLoveseatImage = (shape) => {
    try {
      return require(
        `../../assets/fasteners/fastener-placement-square-${shape.id.toString() === '859' ? 'squared-corners' : shape.slug}.webp`,
      ).default
    } catch (error) {
      console.error('Failed to load image:', error) // eslint-disable-line
      return ''
    }
  }

  _getBenchAndChairWithNoBackImage = (shape, type, isZipperReversed) => {
    try {
      const form = type.id.toString() === '12107' ? 'rectangle' : 'square'
      const corners = shape.id.toString() === '859' ? 'squared-corners' : shape.slug
      const reversed = isZipperReversed && shape.id.toString() === '729' ? '-reversed' : ''

      if (shape.slug === 'circle') {
        return require(`../../assets/fasteners/fastener-placement-circle.webp`).default
      }

      if (type.id === '11658' || type.id === '11660') {
        return require(`../../assets/fasteners/bench/${shape.slug}${reversed}.webp`).default
      }
      return require(`../../assets/fasteners/fastener-placement-${form}-${corners}${reversed}.webp`)
        .default
    } catch (error) {
      console.error('Failed to load image:', error) // eslint-disable-line
      return ''
    }
  }

  _getBedCushionImage = (shape, isZipperReversed) => {
    try {
      return require(
        `../../assets/fasteners/fastener-placement-rectangle-${shape.id.toString() === '859' ? 'squared-corners' : shape.slug}${isZipperReversed && shape.id.toString() === '729' ? '-reversed' : ''}.webp`,
      ).default
    } catch (error) {
      console.error('Failed to load image:', error) // eslint-disable-line
      return ''
    }
  }

  _renderFastenerCheckboxes = (indexOffset) => {
    const { isChaise, checkboxes, mirroredCheckboxes } = this.state
    const { params } = this.props
    const { category, type, shape } = params
    // Render checkboxes 2 by 2 so that they can be tied together
    if (category === '28' || type.id === '11569' || type.id === '12072') {
      return [...Array(4)].map((_, index) => {
        const shouldCheckMirroredCheckbox = index !== 0 && index + indexOffset !== 4
        return (
          <FastenerCheckboxes
            initialCheck={checkboxes[index + indexOffset] === 1}
            initialMirroredCheck={mirroredCheckboxes[index + indexOffset] === 1}
            onClick={this._setFastenerPlacement(index + indexOffset, shouldCheckMirroredCheckbox)}
            key={index}
            shouldCheckMirroredCheckbox={shouldCheckMirroredCheckbox}
            checkboxClassname={'cushion-fastener-placement-checkbox'}
            firstCheckboxClass={`cushion-fastener-placement-checkbox-square-${index + 1}`}
            secondCheckboxClass={`cushion-fastener-placement-checkbox-square-${index + 1}-mirror`}
          />
        )
      })
    } else if (isChaise) {
      // type.id 11568 is Chaise
      // shape 736 - 11 checkboxes
      // shape 735 - 9 checkboxes
      // shape 734 - 7 checkboxes
      // We don't need any ugly switch statements, just pure Maf
      const numberOfCheckboxes = 11 + ((+shape.id - 739) % 3) * 2

      return [...Array(numberOfCheckboxes)].map((_, index) => {
        const checkboxIndex = index + 1
        return (
          <FastenerCheckboxes
            key={index}
            shouldCheckMirroredCheckbox
            initialCheck={checkboxes[index + indexOffset] === 1}
            initialMirroredCheck={mirroredCheckboxes[index + indexOffset] === 1}
            onClick={this._setFastenerPlacement(index, true)}
            checkboxClassname="cushion-fastener-placement-checkbox"
            firstCheckboxClass={`cushion-fastener-placement-checkbox-${checkboxIndex}-chaise-${((+shape.id - 734) % 3) + 1 + '-breaks'}`}
            secondCheckboxClass={`cushion-fastener-placement-checkbox-${checkboxIndex}-chaise-${((+shape.id - 734) % 3) + 1 + '-breaks'}-mirror`}
            moveBreakFastener={0}
          />
        )
      })
    }

    let nrOfCheckboxes = 5
    return [...Array(nrOfCheckboxes)].map((_, index) => {
      const shouldCheckMirroredCheckbox = type.id === '11568' ? index !== 0 : true
      let checkboxIndex = index + 1
      let moveBreakFastener = 0

      return (
        <FastenerCheckboxes
          initialCheck={checkboxes[index + indexOffset] === 1}
          initialMirroredCheck={mirroredCheckboxes[index + indexOffset] === 1}
          onClick={this._setFastenerPlacement(index, shouldCheckMirroredCheckbox)}
          key={index}
          shouldCheckMirroredCheckbox={shouldCheckMirroredCheckbox}
          checkboxClassname={'cushion-fastener-placement-checkbox '}
          firstCheckboxClass={`cushion-fastener-placement-checkbox-${checkboxIndex}${type.id === '11568' ? '-chaise' : ''}`}
          secondCheckboxClass={`cushion-fastener-placement-checkbox-${checkboxIndex}${type.id === '11568' ? '-chaise' : ''}-mirror`}
          moveBreakFastener={moveBreakFastener}
        />
      )
    })
  }

  _generateChaiseZippers = (shape) => {
    return Array(shape?.id ? ((shape?.id + 1) % 3) + 2 : 0)
      ?.fill(0)
      ?.map((_, index) => {
        return this._renderZipper(
          `cushion-fastener-placement-chaise-zipper-${((shape?.id + 1) % 3) + 1}-${index + 1}`,
          index,
        )
      })
  }

  _generateChaiseIndexes = (shape) => {
    return Array(shape?.id ? ((shape?.id + 1) % 3) + 2 : 0)
      ?.fill(0)
      ?.map((_, index) => {
        return (
          <div
            key={`cushion-fastener-placement-chaise-index-${((shape?.id + 1) % 3) + 1}-${index + 1}`}
            className={`cushion-fastener-placement-chaise-index-${((shape?.id + 1) % 3) + 1}-${index + 1}`}
          >
            <span className={'cushion-fastener-placement-chaise-index-text'}>{index + 1}</span>
          </div>
        )
      })
  }

  _renderZipper = (customClassName, index) => {
    return (
      <div
        className={`cushion-fastener-placement-zipper-container ${customClassName}`}
        key={`cushion-zipper-${index}`}
      >
        <span className={'cushion-fastener-placement-zipper-text'}>Zipper</span>
        <img
          className={'cushion-fastener-placement-zipper-image'}
          src={`${APP_URL}/wp-content/uploads/2022/01/double-arrow.png`}
        />
      </div>
    )
  }

  render() {
    const { isMobileLayout } = this.state
    const { params, cushion, general, currentLocationIndex } = this.props
    const { category, type } = params
    const { cushionDimensions } = cushion
    const { dimensions, shape, additionalShape, fasteners, zipperOrientation } = general
    const hasZipperOrientation = getHasZipperOrientation(general)
    const isZipperReversed = hasZipperOrientation && zipperOrientation
    const reactangleTypeIds = ['11660', '11658', '12107']

    return (
      <div className={'cushion-fastener-placement-selector'}>
        <StepTitle
          name="Select Fastener Placement"
          step={currentLocationIndex - 1}
          attributes={general?.type?.attributes}
        />
        <div className="cushion-fastener-placement-selector-grid">
          <div className="cushion-fastener-placement-indications">
            {fasteners?.id === 721 ? (
              <>
                <p>Steel Snap fasteners are two 1” wide by 7” long fabric strips;</p>
                <p>Steel Snap male/Steel Snap female is applied to each fabric strip.</p>
              </>
            ) : fasteners?.id === 720 ? (
              <p>
                Tie fasteners are two 3/8” wide by 12” long fabric strips; each piece ties to the
                other.
              </p>
            ) : fasteners?.id === 719 ? (
              <>
                <p>Velcro fasteners are two, 1” wide by 3.5” long strips each;</p>
                <p>Velcro soft/Velcro hard is applied to each fabric strip.</p>
              </>
            ) : null}
            <p className="details first">Standard fastener placement is as follows:</p>
            <p className="details">Corner fasteners = exact corners of your cushion</p>
            <div className="no-dots details">
              <p>Center fasteners = center of your cushion</p>
              <p>Indented fasteners = two inches from the corner</p>
              <p>
                If you require placement of or fastening applied differently from the above
                standard, please inform us in the comment box inside the shopping cart, and Customer
                Service will contact you for confirmation.
              </p>
            </div>
            <ul className="details">
              <li>Center fasteners = center of your cushion</li>
              <li>Indented fasteners = two inches from the corner</li>
              <li>
                If you require placement of or fastening applied differently from the above
                standard, please inform us in the comment box inside the shopping cart, and Customer
                Service will contact you for confirmation.
              </li>
            </ul>
          </div>
          <div
            className={`dimensions-landmark ${type.id.toString() === '12107' ? 'bed-cushion-landmark' : ''} ${general.type.slug} ${shape?.slug === 'trapezoid' ? 'trapezoid-shape' : ''}`}
          >
            {isMobileLayout ? (
              <>
                <div className={'cushion-fastener-placement-diagrams-container'}>
                  {(category === '28' && type.id !== '166') || type.id === '11569' ? (
                    <>
                      <div
                        className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram' : 'cushion-fastener-placement-diagram diagram-square'}`}
                      >
                        {this._renderFastenerCheckboxes(0)}
                        <span className={'cushion-fastener-placement-diagram-text'}>Zipper</span>
                        <img
                          className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram-arrow-image' : 'cushion-fastener-placement-diagram-arrow-image chair-arrow'}`}
                          src={`${APP_URL}/wp-content/uploads/2022/01/double-arrow.png`}
                        />
                        <img
                          className={`${reactangleTypeIds.includes(type.id) ? `${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram-image' : 'cushion-fastener-placement-diagram-image-square'}` : 'cushion-fastener-placement-diagram-image-square'}`}
                          src={this._getLoveseatImage(shape)}
                        />
                      </div>
                      <div
                        className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram' : 'cushion-fastener-placement-diagram diagram-square'}`}
                      >
                        {this._renderFastenerCheckboxes(4)}
                        <span className={'cushion-fastener-placement-diagram-text'}>Zipper</span>
                        <img
                          className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram-arrow-image' : 'cushion-fastener-placement-diagram-arrow-image chair-arrow'}`}
                          src={`${APP_URL}/wp-content/uploads/2022/01/double-arrow.png`}
                        />
                        <img
                          className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram-image' : 'cushion-fastener-placement-diagram-image-square'}`}
                          src={this._getLoveseatImage(additionalShape)}
                        />
                      </div>
                    </>
                  ) : type.id === '11568' ? (
                    <div
                      className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram' : 'cushion-fastener-placement-diagram diagram-square'}`}
                    >
                      {this._renderFastenerCheckboxes(0)}
                      {this._generateChaiseZippers(shape)}
                      {this._generateChaiseIndexes(shape)}
                      <img
                        className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram-image' : 'cushion-fastener-placement-diagram-image-square'}`}
                        src={this._getChaiseImage(shape)}
                      />
                    </div>
                  ) : (
                    <div
                      className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram' : 'cushion-fastener-placement-diagram diagram-square'}`}
                    >
                      {this._renderFastenerCheckboxes(0)}
                      {type.id !== '11568' && (
                        <>
                          <span className={'cushion-fastener-placement-diagram-text'}>Zipper</span>
                          <img
                            className={`cushion-fastener-placement-diagram-arrow-image ${reactangleTypeIds.includes(type.id) ? shape.slug : 'square'}`}
                            src={`${APP_URL}/wp-content/uploads/2022/01/double-arrow.png`}
                          />
                        </>
                      )}
                      <img
                        className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram-image' : 'cushion-fastener-placement-diagram-image-square'}`}
                        src={this._getBenchAndChairWithNoBackImage(shape, type, isZipperReversed)}
                      />
                    </div>
                  )}
                </div>
                <div
                  className={`${general?.type?.slug === 'chaise' ? `${general?.shape?.slug}` : general?.type?.slug} ${['custom'].includes(general?.shape?.slug) ? general?.shape?.slug : ''}`}
                >
                  {Object.keys(cushionDimensions).map((dimension, index) => (
                    <div key={`${dimension}-${index}`} className={`attribute ${dimension}`}>
                      <div className={'attribute-text'}>
                        <p className={' bold-letter '}>{letters[index].toUpperCase()}</p>
                      </div>
                      <label className={'dimension'}>
                        <span>{dimensions[dimension]}</span>
                      </label>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div
                  className={`${general?.type?.slug === 'chaise' ? `${general?.shape?.slug}` : general?.type?.slug} ${['custom'].includes(general?.shape?.slug) ? general?.shape?.slug : ''}`}
                >
                  {Object.keys(cushionDimensions).map((dimension, index) => (
                    <div key={`${dimension}-${index}`} className={`attribute ${dimension}`}>
                      <div className={'attribute-text'}>
                        <p className={' bold-letter '}>{letters[index].toUpperCase()}</p>
                      </div>
                      <label className={'dimension'}>
                        <span>{dimensions[dimension]}</span>
                      </label>
                    </div>
                  ))}
                </div>
                <div
                  className={`${type.id === '12072' || type.id === '12090' || type.id === '11864' || type.id === '11786' || type.id === '166' ? 'cushion-fastener-placement-diagrams-container chair-with-no-back-width' : type.id === '11568' ? 'cushion-fastener-placement-diagrams-container fastener-for-chaise' : 'cushion-fastener-placement-diagrams-container'}`}
                >
                  {(category === '28' && type.id !== '166') || type.id === '11569' ? (
                    <>
                      <div
                        className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram' : 'cushion-fastener-placement-diagram diagram-square'}`}
                      >
                        {this._renderFastenerCheckboxes(0)}
                        <span className={'cushion-fastener-placement-diagram-text'}>Zipper</span>
                        <img
                          className={'cushion-fastener-placement-diagram-arrow-image'}
                          src={`${APP_URL}/wp-content/uploads/2022/01/double-arrow.png`}
                        />
                        <img
                          className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram-image' : 'cushion-fastener-placement-diagram-image-square'}`}
                          src={this._getLoveseatImage(shape)}
                        />
                      </div>
                      <div
                        className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram' : 'cushion-fastener-placement-diagram diagram-square'}`}
                      >
                        {this._renderFastenerCheckboxes(4)}
                        <span
                          className={`${type?.id === '11786' || type?.id === '11864' || type?.id === '12090' ? 'cushion-fastener-placement-diagram-text-down' : 'cushion-fastener-placement-diagram-text'}`}
                        >
                          Zipper
                        </span>
                        <img
                          className={`${type?.id === '11786' || type?.id === '11864' || type?.id === '12090' ? 'cushion-fastener-placement-diagram-arrow-image-down' : 'cushion-fastener-placement-diagram-arrow-image'}`}
                          src={`${APP_URL}/wp-content/uploads/2022/01/double-arrow.png`}
                        />
                        <img
                          className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram-image' : 'cushion-fastener-placement-diagram-image-square'}`}
                          src={this._getLoveseatImage(additionalShape)}
                        />
                      </div>
                    </>
                  ) : type.id === '11568' ? (
                    <div
                      className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram' : 'cushion-fastener-placement-diagram diagram-square'}`}
                    >
                      {this._renderFastenerCheckboxes(0)}
                      {this._generateChaiseZippers(shape)}
                      {this._generateChaiseIndexes(shape)}
                      <img
                        className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram-image' : 'cushion-fastener-placement-diagram-image-square'}`}
                        src={this._getChaiseImage(shape)}
                      />
                    </div>
                  ) : (
                    <div
                      className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram' : 'cushion-fastener-placement-diagram diagram-square'}`}
                    >
                      {this._renderFastenerCheckboxes(0)}
                      {type.id !== '11568' && (
                        <>
                          <span className={'cushion-fastener-placement-diagram-text'}>Zipper</span>
                          <img
                            className={`cushion-fastener-placement-diagram-arrow-image ${type?.id === '12072' ? 'chair-with-no-back' : shape.slug} ${general?.type?.slug}`}
                            src={`${APP_URL}/wp-content/uploads/2022/01/double-arrow.png`}
                          />
                        </>
                      )}
                      <img
                        className={`${reactangleTypeIds.includes(type.id) ? 'cushion-fastener-placement-diagram-image' : 'cushion-fastener-placement-diagram-image-square'}`}
                        src={this._getBenchAndChairWithNoBackImage(shape, type, isZipperReversed)}
                      />
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
  cushion: state.cushion,
})
export default connect(mapStateToProps)(withRoutingTracker(CushionFastenerPlacementSelector))
